// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"af99a12b","158":"f35ff399","237":"72fd7483"}[chunkId] + ".chunk.css";
};